import { ReactNode } from 'react';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface CardSectionHeaderProps {
  title: string;
  titleVariant?: 'h2' | 'body1' | 'body2';
  titleColor?: string;
  action?: ReactNode;
  isActionWrappable?: boolean;
  marginBottom?: number;
}
const CardSectionHeader = ({
  title,
  titleVariant = 'h2',
  titleColor = undefined,
  action = null,
  isActionWrappable = false,
  marginBottom = 2,
}: CardSectionHeaderProps) => (
  <Stack
    direction={isActionWrappable ? 'row' : { xs: 'column', sm: 'row' }}
    flexWrap={isActionWrappable ? 'wrap' : 'nowrap'}
    justifyContent="space-between"
    alignItems={{ xs: 'flex-start', sm: 'center' }}
    rowGap={1}
    mb={marginBottom}
  >
    <Typography
      variant={titleVariant}
      sx={{
        maxWidth: { xs: 450, sm: 600 },
        overflowWrap: 'break-word',
        color: titleColor,
        pr: 1,
      }}
    >
      {title}
    </Typography>

    {action && (
      <Stack
        direction="row"
        alignItems="center"
        width={{
          xs: isActionWrappable ? 'auto' : '100%',
          sm: 'auto',
        }}
      >
        {action}
      </Stack>
    )}
  </Stack>
);

export default CardSectionHeader;
